import jwtAuthAxios from "../auth/jwtAuth";
import { getBEUrlForAdmin } from "./management";

function setDlaDomain(beDomain) {
  jwtAuthAxios.defaults.baseURL = `${getBEUrlForAdmin(beDomain)}/`;
}

export async function getDlaStatus(connectionCode, beDomain) {
  setDlaDomain(beDomain);
  const { data } = await jwtAuthAxios.get(
    `/api/v1/agents/${encodeURIComponent(String(connectionCode))}/status`,
  );
  return data;
}

export async function pingDla(connectionCode, beDomain) {
  setDlaDomain(beDomain);
  const { data } = await jwtAuthAxios.post(
    `/api/v1/agents/${encodeURIComponent(String(connectionCode))}/commands/ping`,
  );
  return data;
}

export async function getDlaLogsMeta(connectionCode, beDomain) {
  setDlaDomain(beDomain);
  const { data } = await jwtAuthAxios.post(
    `/api/v1/agents/${encodeURIComponent(String(connectionCode))}/commands/get-logs-meta`,
  );
  return data;
}

export async function downloadDlaLogs(connectionCode, date, beDomain) {
  setDlaDomain(beDomain);
  const { data } = await jwtAuthAxios.post(
    `/api/v1/agents/${encodeURIComponent(String(connectionCode))}/commands/get-logs`,
    { date },
    { responseType: "blob" },
  );
  return data;
}
